import SETTINGS from '#/config/global-settings';

export const DEPOSIT_AMOUNT_SCALE = SETTINGS.fiat.USD.scale;
